/* eslint-disable indent */
import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
  color?: string
}

const UserSyncIconOutline = createIcon({
  displayName: 'UserSyncIconOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <rect width="24" height="24"></rect>
        <circle cx="12" cy="7.25" r="4.25" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"></circle>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M4 19v0l5.15143e-14 6.79481e-07c-3.75267e-07-2.48528 2.01472-4.5 4.5-4.5h2.583"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M19.246 17.34l.516-.516 1.0233e-08 2.40054e-08c.649713 1.52415-.0591602 3.28642-1.58331 3.93613 -.532836.227137-1.12003.295165-1.69069.19587"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M14.734 18.658l-.516.516 -2.76118e-08-6.45813e-08c-.651353-1.52345.0556225-3.28648 1.57907-3.93783 .588433-.251585 1.2419-.308408 1.86493-.162167"
        ></path>
      </g>
    </>
  ),
})

const UserSync: FC<CustomIconProps> = (props) => {
  switch (props.variant || 'outline') {
    default:
      return <CustomIcon as={UserSyncIconOutline} {...props} />
  }
}

export default memo(UserSync)
